"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Ruby_Jackpot_2_lines_big_png_1 = __importDefault(require("../../../../../assets/rubyJackpot/images/logo/Ruby-Jackpot-2-lines-big.png"));
var selectors_1 = require("../../../../../contexts/rubyJackpot/selectors");
var ISliders_1 = require("../../interfaces/ISliders");
var BigPostersContainer_1 = __importDefault(require("../GamesContainer/BigPostersContainer"));
var JackpotWinners_1 = __importDefault(require("../JackpotWinnersContainer/JackpotWinners"));
var DefaultWrapper_1 = __importDefault(require("./DefaultWrapper"));
var SwitchButtons_1 = __importDefault(require("./switchButtons/SwitchButtons"));
var Wrapper = function (_a) {
    var features = _a.features, redirectURL = _a.redirectURL, mobileWidth = _a.mobileWidth;
    var games = (0, selectors_1.useGames)();
    var isPlainAmount = false;
    var _b = (0, react_1.useState)(ISliders_1.SliderTypes.ParticipatingGames), currentSlider = _b[0], setCurrentSlider = _b[1];
    var _c = (0, react_1.useState)(false), isMobile = _c[0], setIsMobile = _c[1];
    var getRandomGame = function () {
        // const gamesLength = games.length;
        // const gameIndex = Math.floor(Math.random() * gamesLength);
        // const selectedGame = games[gameIndex];
        // const gameMap = getGame(selectedGame.code);
        // onClickHandle();
    };
    (0, react_1.useEffect)(function () {
        onResize();
        window.addEventListener("resize", onResize, false);
        return function () { return window.removeEventListener("resize", onResize, false); };
    }, []);
    var onResize = function () {
        setIsMobile(window.innerWidth < mobileWidth);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "big-container" }, { children: [isMobile &&
                (0, jsx_runtime_1.jsx)("img", { src: Ruby_Jackpot_2_lines_big_png_1.default, className: "big-container-logo", alt: "logo" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "big-container-wrapper" }, { children: [(0, jsx_runtime_1.jsx)(DefaultWrapper_1.default, { features: features, isPlainAmount: isPlainAmount, redirectURL: redirectURL }), !isMobile && (0, jsx_runtime_1.jsx)(BigPostersContainer_1.default, { isMobile: false, getRandomGame: getRandomGame })] })), isMobile && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SwitchButtons_1.default, { currentSlider: currentSlider, setCurrentSlider: setCurrentSlider, getRandomGame: getRandomGame }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "big-container--mobileWrapper" }, { children: [(0, jsx_runtime_1.jsx)(JackpotWinners_1.default, { isMobile: true, show: currentSlider === ISliders_1.SliderTypes.LatestWinners }), (0, jsx_runtime_1.jsx)(BigPostersContainer_1.default, { isMobile: true, show: currentSlider === ISliders_1.SliderTypes.ParticipatingGames, getRandomGame: getRandomGame })] }))] }), !isMobile && (0, jsx_runtime_1.jsx)(JackpotWinners_1.default, { isMobile: false })] })));
};
exports.default = Wrapper;
